import { HttpHeaders } from '@angular/common/http';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, Validators } from '@angular/forms';
import { CabinPreferences, FlightPreferences, OriginDestination, Passenger, SearchFlightsScreenRequest, Type } from 'src/app/model/request/search-flights-screen-request';
import { AirlineOffersScreen } from 'src/app/model/screen/airline-offers-screen';
import { boundSlider, FilterOffersScreen } from 'src/app/model/screen/filter-offers-screen';
import { SearchFlightsScreen } from 'src/app/model/screen/search-flights-screen';
import { Airport, AirportSearchService } from 'src/app/service/airport-search.service';
import { ApiService } from 'src/app/service/api.service';
import { LocalAssetReaderService } from 'src/app/service/local-asset-reader.service';
import { SandboxPageStateService } from 'src/app/service/sandbox-page-state.service';
import { XmlToJsonParserService } from 'src/app/service/xml-to-json-parser.service';
import searchFlightsJSON from 'src/assets/json/search-flights/request/search-flights-request-default-params.json';

@Component({
  selector: 'app-search-flights-screen',
  templateUrl: './search-flights-screen.component.html',
  styleUrls: ['./search-flights-screen.component.scss']
})
export class SearchFlightsScreenComponent implements OnInit, OnDestroy {
  inputParamsMap = new Map();

  constructor(
    private localAssetReaderService: LocalAssetReaderService,
    private airportSearchService: AirportSearchService,
    private sandboxPageStateService: SandboxPageStateService,
    private apiService: ApiService,
    private formBuilder: FormBuilder,
    private xmlToJsonParserService: XmlToJsonParserService
  ) {
    Object.entries(searchFlightsJSON).forEach((entry) => {
      const [key, value] = entry;
      this.inputParamsMap.set(key, value);
    });
  }

  farePreferencesID: any = [];
  public searchFlightForm: any = 1;
  public totPassenger: number = 1;
  toggleOptions: any = {
    onColor: 'primary',
    offColor: 'secondary',
    disabled: false,
    size: 'sm'
  };

  adults: any = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  youngAdults: any = [0, 1, 2, 3, 4, 5, 6, 7, 8];
  childrens: any = [0, 1, 2, 3, 4, 5, 6, 7, 8];
  infants: any = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  calendarDays: any = [0, 1, 2, 3];
  farePreferenceCodeID: any = [];
  cabinPreferences: any = [
    { code_id: '5', code_name: 'Economy' },
    { code_id: '4', code_name: ' Premium Economy' },
    { code_id: '2', code_name: 'Business' },
    { code_id: '1', code_name: 'First' }
  ];

  farePreferenceList: any = [
    { item_id: '759', item_text: 'Lowest Fare' },
    { item_id: '754', item_text: 'Flexible Fare' },
    { item_id: '736', item_text: 'Refundable Fare' },
    { item_id: '70G', item_text: 'Corporate Fare' },
    { item_id: '70J,759', item_text: 'Non Negotiated (Restricted) fare' },
    { item_id: '70J,754', item_text: 'Non Negotiated (Flexible) fare' },
    { item_id: '758,759', item_text: 'Negotiated (Restricted) fare' },
    { item_id: '758,754', item_text: 'Negotiated (Flexible) fare' },
    { item_id: '758|Tour Operator Deferred', item_text: 'Leisure Fare - Tour Operator Deferred' },
    { item_id: '758|Tour Operator Semi Deferred', item_text: 'Leisure Fare - Tour Operator Semi Deferred' },
    { item_id: '758|Contract Bulk', item_text: 'Leisure Fare - Bulk Contract' },
    { item_id: '758|Private Fare Adult', item_text: 'Leisure Fare - Private Adult' },
    { item_id: '758|Marine', item_text: 'Leisure Fare - Marine' },
    { item_id: '758|Humanitarian', item_text: 'Leisure Fare - Humanitarian' }
  ];

  public airPortSearchList: Airport[] = [];
  public filterSliderList: boundSlider[] = [];
  filterBy = 'City';

  public storeAirPortSearchList = [
    { depatureAirPortSearchList: [], arrivalAirPortSearchList: [] },
    { depatureAirPortSearchList: [], arrivalAirPortSearchList: [] },
    { depatureAirPortSearchList: [], arrivalAirPortSearchList: [] },
    { depatureAirPortSearchList: [], arrivalAirPortSearchList: [] },
    { depatureAirPortSearchList: [], arrivalAirPortSearchList: [] },
    { depatureAirPortSearchList: [], arrivalAirPortSearchList: [] }
  ];

  farePreferenceSettings = {
    singleSelection: false,
    enableCheckAll: false,
    idField: 'item_id',
    textField: 'item_text',
    itemsShowLimit: 1
  };

  formHaveInvalidFields: boolean = true;
  minQueryLength: number = 4;
  searchFlightScreen: SearchFlightsScreen = {} as SearchFlightsScreen;
  searchFlightsScreenRequest: SearchFlightsScreenRequest = {} as SearchFlightsScreenRequest;
  flightPreference: FlightPreferences = {} as FlightPreferences;

  jsonData: any;
  xmlData: any;
  xmlSchema: any;

  ngOnInit() {
    this.searchFlightForm = this.initSearchFlightForm();
    if (this.sandboxPageStateService.getActiveAPIConnectionProfile().connectionName === '') {
      this.sandboxPageStateService.resetActiveAPIConnectionProfile();
    }
  }

  updateAirportData(airportSearchKey: any, type: 'departure' | 'arrival', i: any) {
    if (type === 'departure') {
      this.airPortSearchList = this.storeAirPortSearchList[i]['depatureAirPortSearchList'];
    } else {
      this.airPortSearchList = this.storeAirPortSearchList[i]['arrivalAirPortSearchList'];
    }
  }

  searchAirportsList(airportSearchKey: string, type: 'departure' | 'arrival', i: any) {
    airportSearchKey = airportSearchKey.toUpperCase();
    let len = airportSearchKey.length;
    if (len > 3) {
      if (type === 'departure') {
        airportSearchKey = airportSearchKey.slice(0, 4);
      }
      if (type === 'arrival') {
        airportSearchKey = airportSearchKey.slice(0, 4);
      }
    }
    let destinationArr = this.inp_arr('destination').at(i);
    if (type === 'departure') {
      destinationArr.patchValue({ depature: airportSearchKey });
    } else {
      destinationArr.patchValue({ arrival: airportSearchKey });
    }
    if (len > 0) {
      if (len > 1) {
        this.airPortSearchList = this.airportSearchService.searchAirportByKey(airportSearchKey);
        if (this.airPortSearchList.length > 0) {
          if (type === 'departure') {
            this.storeAirPortSearchList[i]['depatureAirPortSearchList'] = this.airPortSearchList as any;
          } else {
            this.storeAirPortSearchList[i]['arrivalAirPortSearchList'] = this.airPortSearchList as any;
          }
        }
      }
    } else {
      this.airPortSearchList = [];
      if (type === 'departure') {
        this.storeAirPortSearchList[i]['depatureAirPortSearchList'] = [];
      } else {
        this.storeAirPortSearchList[i]['arrivalAirPortSearchList'] = [];
      }
    }
  }
  removeAirportList(type: 'departure' | 'arrival', i: any) {
    this.airPortSearchList = [];
    if (type === 'departure') {
      this.storeAirPortSearchList[i]['depatureAirPortSearchList'] = [];
    } else {
      this.storeAirPortSearchList[i]['arrivalAirPortSearchList'] = [];
    }
  }
  setValue(airportSearchKey: any, type: 'departure' | 'arrival', i: any) {
    let destinationArr = this.inp_arr('destination').at(i);
    if (type === 'departure') {
      destinationArr.patchValue({
        depature: airportSearchKey.LocationCode
      });
    } else {
      destinationArr.patchValue({
        arrival: airportSearchKey.LocationCode
      });
    }
  }

  getDefaultPassenger(): Passenger {
    const passenger: Passenger = {} as Passenger;
    passenger.$ = { PassengerID: this.inputParamsMap.get('##Passenger##PassengerID##') };
    passenger.PTC = this.inputParamsMap.get('##Passenger##PTC##');
    passenger.Birthdate = this.inputParamsMap.get('##Passenger##Birthdate##');
    passenger.ResidenceCountryCode = this.inputParamsMap.get('##Passenger##ResidenceCountryCode##');
    passenger.CitizenshipCountryCode = this.inputParamsMap.get('##Passenger##CitizenshipCountryCode##');
    return passenger;
  }

  addPassenger(passengerCount: number, type: 'ADT' | 'CHD' | 'INF', dob: any) {
    for (let i = 1; i <= passengerCount; i++) {
      let passenger = this.getDefaultPassenger();
      passenger.$.PassengerID = 'SH' + this.totPassenger;
      passenger.PTC = type;
      passenger.Birthdate = dob;
      this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.DataLists.PassengerList.Passenger.push(passenger);
      this.totPassenger++;
    }
  }

  getDefaultCabinPreference(): CabinPreferences {
    const cabinPreference: CabinPreferences = {} as CabinPreferences;
    cabinPreference.CabinType.Code = this.inputParamsMap.get('##CabinType##Code##');
    return cabinPreference;
  }

  addCabinPreferences(selectedCabinPreference: any, type: any) {
    var cabinPreference: any = [];
    selectedCabinPreference.forEach((element: any) => {
      let preference = this.getDefaultCabinPreference();
      preference.CabinType = element.item_id;
      cabinPreference.push(preference);
    });
    return cabinPreference;
  }

  addDestination(depatureLocationCode: any, travelDate: any, arrivalLocationCode: any, outbounddepartureTime?: any, inbounddepartureTime?: any, dateBefore?: any, dateAfter?: any) {
    let destination: OriginDestination = {} as OriginDestination;

    if (outbounddepartureTime !== '') {
      destination.Departure = { AirportCode: depatureLocationCode, Date: travelDate, Time: outbounddepartureTime };
    } else if (inbounddepartureTime !== '') {
      destination.Departure = { AirportCode: depatureLocationCode, Date: travelDate, Time: inbounddepartureTime };
    } else {
      destination.Departure = { AirportCode: depatureLocationCode, Date: travelDate };
    }
    destination.Arrival = { AirportCode: arrivalLocationCode };
    destination.CalendarDates = { $: { DaysBefore: dateBefore, DaysAfter: dateAfter } };

    return destination;
  }

  async searchAirlineOffers() {
    this.filterSliderList = [];
    this.sandboxPageStateService.resetSandboxPage();
    this.farePreferencesID = [];
    let patchSandboxSourceData: any = '';
    let farePreference: any = this.searchFlightForm.value.farePreference;

    patchSandboxSourceData = { showError: 'No' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);

    await this.initSearchFlightsScreenRequest();

    //await this.deletePrefrences('FlightPreferences');
    let flightPreferenceData = this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Preference;
    if (this.searchFlightForm.value.connections) {
      delete flightPreferenceData['FlightPreferences'];
    }
    this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Preference;

    if (farePreference.length > 0) {
      let searchFlightFormValue = this.searchFlightForm.value;
      searchFlightFormValue.farePreference.forEach((farePreferenceDetails: any) => {
        let farePreferenceDetailsArray = farePreferenceDetails.item_id.split('|');
        let farePreferenceIds = farePreferenceDetailsArray[0].split(',');
        farePreferenceIds.forEach((fareCode: any) => {
          let farePreference = {} as Type;
          if (farePreferenceDetailsArray.length === 2) {
            farePreference.$ = {};
            farePreference.$.PreferencesContext = farePreferenceDetailsArray[1];
          }
          farePreference._ = fareCode;
          this.farePreferencesID.push(farePreference);
        });
      });

      if (searchFlightFormValue.fareRules) {
        let farePreference: any = {};
        farePreference._ = '722';
        this.farePreferencesID.push(farePreference);
      }
      this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Preference.FarePreferences!.Types.Type = this.farePreferencesID;
    } else {
      //  await this.deletePrefrences('FarePreferences');
      let farePreferences = this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Preference;
      delete farePreferences['FarePreferences'];
      this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Preference;
    }

    await this.apiService.getXMLResponse(this.sandboxPageStateService.SEARCH_FLIGHTS_SCREEN_URL, JSON.stringify(this.searchFlightsScreenRequest), this.inputParamsMap, {
      headers: new HttpHeaders({
        soapAction: 'AirShopping17_2_V1'
      }),
      responseType: 'text'
    });

    this.updateAirlineOffersScreenXML(this.sandboxPageStateService.SEARCH_FLIGHTS_SCREEN_URL);
  }

  getFormatDated(date: Date): string {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${year}-${month}-${day}`;
  }

  private async initSearchFlightsScreenRequest() {
    this.formHaveInvalidFields = true;
    let searchFlightFormValue = this.searchFlightForm.value;
    let cabinPreferenceCode = searchFlightFormValue.cabinPreferences;
    let jsonRequestTemplate = await this.localAssetReaderService.getContent(this.sandboxPageStateService.SEARCH_FLIGHTS_REQUEST_TEMPLATE);
    this.searchFlightsScreenRequest = JSON.parse(jsonRequestTemplate as any);
    this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.DataLists.PassengerList.Passenger = [];
    this.searchFlightsScreenRequest = JSON.parse(jsonRequestTemplate as any);
    this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.DataLists.PassengerList.Passenger = [];
    this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Preference.CabinPreferences.CabinType.Code = cabinPreferenceCode;
    let currentTimeStamp = new Date();
    let currentYear = currentTimeStamp.getFullYear();
    let adultAge = this.getFormatDated(new Date(currentYear - 30, currentTimeStamp.getMonth(), currentTimeStamp.getDate()));
    let youngAdultAge = this.getFormatDated(new Date(currentYear - 15, currentTimeStamp.getMonth(), currentTimeStamp.getDate()));
    let childAge = this.getFormatDated(new Date(currentYear - 5, currentTimeStamp.getMonth(), currentTimeStamp.getDate()));
    let infantAge = this.getFormatDated(new Date(currentYear - 1, currentTimeStamp.getMonth(), currentTimeStamp.getDate()));
    this.totPassenger = 1;
    this.addPassenger(searchFlightFormValue.adults, 'ADT', adultAge);
    if (searchFlightFormValue.youngAdults != 0) {
      this.addPassenger(searchFlightFormValue.youngAdults, 'ADT', youngAdultAge);
    }
    if (searchFlightFormValue.childs != 0) {
      this.addPassenger(searchFlightFormValue.childs, 'CHD', childAge);
    }
    if (searchFlightFormValue.infants != 0) {
      this.addPassenger(searchFlightFormValue.infants, 'INF', infantAge);
    }
    this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.CoreQuery.OriginDestinations.OriginDestination = [];
    if (!searchFlightFormValue.luggage) {
      this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Qualifier!.BaggagePricingQualifier!.BaggageOption = '1';
    } else {
      this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Qualifier!.BaggagePricingQualifier!.BaggageOption;
      let baggageData = this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ;
      delete baggageData['Qualifier'];
      this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.Qualifier;
    }
    let destinationList = searchFlightFormValue.destination;
    let destinationListLen = destinationList.length;
    if (destinationListLen > 0) {
      let i = 0;
      destinationList.forEach((destination: any) => {
        let depatureDate = destination.depatureDate;
        let depatureCode = destination.depature.LocationCode;
        if (typeof depatureCode === 'undefined') {
          depatureCode = destination.depature;
        }
        let arrivalCode = destination.arrival.LocationCode;
        if (typeof arrivalCode === 'undefined') {
          arrivalCode = destination.arrival;
        }

        let outbounddepartureTime: any = this.searchFlightForm.value.destination[0].outbounddepartureTime;
        let inbounddepartureTime: any = this.searchFlightForm.value.destination[0].inbounddepartureTime;
        let dateBefore: any = this.searchFlightForm.value.calenderDays1;
        let dateAfter: any = this.searchFlightForm.value.calenderDays2;

        depatureCode = depatureCode === '' ? ' ' : depatureCode;
        arrivalCode = arrivalCode === '' ? ' ' : arrivalCode;
        depatureDate = depatureDate === '' ? '0001-01-01' : depatureDate;
        outbounddepartureTime = outbounddepartureTime === '' ? '' : outbounddepartureTime;
        inbounddepartureTime = inbounddepartureTime === '' ? '' : inbounddepartureTime;

        dateBefore = dateBefore === '' ? '' : dateBefore;
        dateAfter = dateAfter === '' ? '' : dateAfter;

        if (depatureCode !== ' ') {
          if (this.formHaveInvalidFields) {
            this.formHaveInvalidFields = depatureCode !== ' ' && arrivalCode !== ' ' ? true : false;
          }

          let destinationDetail = this.addDestination(depatureCode, depatureDate, arrivalCode, outbounddepartureTime, '', dateBefore, dateAfter);
          this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.CoreQuery.OriginDestinations.OriginDestination.push(destinationDetail);
        }
        if (searchFlightFormValue.haveReturn && i == 0) {
          let returnDate = searchFlightFormValue.returnDate;
          let depatureCode = destination.arrival.LocationCode;
          if (typeof depatureCode === 'undefined') {
            depatureCode = destination.arrival;
          }
          let arrivalCode = destination.depature.LocationCode;
          if (typeof arrivalCode === 'undefined') {
            arrivalCode = destination.depature;
          }
          returnDate = returnDate === '' ? depatureDate : returnDate;

          if (depatureCode !== '' && arrivalCode !== '' && returnDate !== '') {
            let destinationDetail = this.addDestination(depatureCode, returnDate, arrivalCode, '', inbounddepartureTime, dateBefore, dateAfter);
            this.searchFlightsScreenRequest['S:Envelope']['S:Body'].AirShoppingRQ.CoreQuery.OriginDestinations.OriginDestination.push(destinationDetail);
          }
        }
        i++;
      });
    }
  }

  updateAirlineOffersScreenXML(url: string) {
    let patchSandboxSourceData: any = '';

    if (this.sandboxPageStateService.getErrorMessage() !== '') {
      if (this.formHaveInvalidFields === false) {
        patchSandboxSourceData = {
          showError: 'Yes',
          errorMessage: 'The remote server returned an error: (500) Internal Server Error.'
        };
        this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      } else if (this.sandboxPageStateService.getErrorMessage() === 'Unable to process - system error NDC_AIRSHOPPING_9007 - Error getting priced availability.') {
        let errorMessage: any;
        if (typeof this.sandboxPageStateService.getErrorMessage() !== 'undefined') {
          errorMessage = 'There is no flight available for the given date or time';
          patchSandboxSourceData = { showError: 'Yes', errorMessage: errorMessage };
          this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
        }
      } else {
        patchSandboxSourceData = { showError: 'Yes', errorMessage: this.sandboxPageStateService.getErrorMessage() };
        this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
      }
    } else {
      let airlineOffersScreen: AirlineOffersScreen = {} as AirlineOffersScreen;

      airlineOffersScreen.airlineOffers = [];
      airlineOffersScreen.airlineFilterData = {
        airportList: [],
        priceClassList: [],
        operaterList: []
      };
      let searchFlightScreenValue = this.searchFlightForm.value;
      let sliderDefaultValue: boundSlider[] = [
        {
          label: 'OutBound',
          startTime: 0,
          endTime: 2400
        },
        {
          label: 'InBound',
          startTime: 0,
          endTime: 2400
        }
      ];
      if (!searchFlightScreenValue.haveReturn) {
        sliderDefaultValue.splice(1, 1);
      }
      let filterOffersScreen: FilterOffersScreen = {
        airportList: [],
        priceClassList: [],
        operaterList: [],
        boundSliders: sliderDefaultValue
      };

      airlineOffersScreen.xml = this.sandboxPageStateService.getResponseFromMap(url);

      airlineOffersScreen.jsonData = this.xmlToJsonParserService.parseXMLToJSON(airlineOffersScreen.xml!);

      this.sandboxPageStateService.updateAirlineOffersScreenData(airlineOffersScreen);
      this.sandboxPageStateService.updateFilterOffersScreenData(filterOffersScreen);

      patchSandboxSourceData = { mainMenu: 'none', sandboxScreen: 'search-flights-screen' };
      this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
    }
  }

  setReturnDate() {
    let depatureDate = this.inp_arr('destination').value[0]['depatureDate'];
    let returnDate = this.searchFlightForm.value.returnDate;
    if (returnDate === '' || returnDate < depatureDate) {
      returnDate = depatureDate;
    }
    this.searchFlightForm.patchValue({
      returnDate: returnDate
    });
  }

  initSearchFlightForm() {
    let sandboxSourceData: any = 1;
    this.sandboxPageStateService.sandboxScreenDataSource.subscribe((res: any) => {
      if (typeof res.searchFlightFormValue != 'undefined') {
        sandboxSourceData = res.searchFlightFormValue;
      }
    });
    let haveReturn = true;
    let returnDate = '';
    let haveMultiCity = true;
    let adults = 1;
    let youngAdults = 0;
    let childs = 0;
    let infants = 0;
    let calenderDays1 = 0;
    let calenderDays2 = 0;
    let fareRules = true;
    let connections = true;
    let luggage = true;
    let shortSell = true;
    let cabinPreferences: any = '5';
    let farePreference: any = [this.farePreferenceList[0]];

    let destinationArr = this.formBuilder.array([]);
    if (sandboxSourceData != 1) {
      let existingDestinationList = sandboxSourceData.destination;
      let existingDestinationLen = existingDestinationList.length;
      existingDestinationList.forEach((y: any) => {
        if (typeof y.depature.LocationCode !== 'undefined') {
          y.depature = y.depature.LocationCode;
        }
        if (typeof y.arrival.LocationCode !== 'undefined') {
          y.arrival = y.arrival.LocationCode;
        }
        let fromGroup: any = this.formBuilder.group({
          depature: [y.depature, [Validators.required]],
          arrival: [y.arrival, [Validators.required]],
          depatureDate: [y.depatureDate, [Validators.required]],
          outbounddepartureTime: [y.outbounddepartureTime],
          inbounddepartureTime: [y.inbounddepartureTime]
        });
        destinationArr.push(fromGroup);
      });
      haveMultiCity = existingDestinationLen == 1 ? true : false;
      haveReturn = sandboxSourceData.haveReturn;
      returnDate = sandboxSourceData.returnDate;
      adults = sandboxSourceData.adults;
      youngAdults = sandboxSourceData.youngAdults;
      childs = sandboxSourceData.childs;
      infants = sandboxSourceData.infants;
      cabinPreferences = sandboxSourceData.cabinPreferences;
      fareRules = sandboxSourceData.fareRules;
      luggage = sandboxSourceData.luggage;
      connections = sandboxSourceData.connections;
      shortSell = sandboxSourceData.shortSell;
      calenderDays1 = sandboxSourceData.calenderDays1;
      calenderDays2 = sandboxSourceData.calenderDays2;
      farePreference = sandboxSourceData.farePreference;
    } else {
      let fromGroup: any = this.formBuilder.group({
        depature: ['', [Validators.required]],
        arrival: ['', [Validators.required]],
        depatureDate: ['', [Validators.required]],
        outbounddepartureTime: [''],
        inbounddepartureTime: [''],
        ArrivalTime: [''],
        calenderDays1: [''],
        calenderDays2: ['']
      });
      destinationArr.push(fromGroup);
    }
    return this.formBuilder.group({
      destination: destinationArr,
      haveReturn: [haveReturn],
      returnDate: [returnDate],
      haveMultiCity: [haveMultiCity],
      adults: [adults],
      youngAdults: [youngAdults],
      childs: [childs],
      infants: [infants],
      cabinPreferences: [cabinPreferences],
      fareRules: [fareRules],
      connections: [connections],
      luggage: [luggage],
      shortSell: [shortSell],
      calenderDays1: [calenderDays1],
      calenderDays2: [calenderDays2],
      farePreference: [farePreference]
    });
  }

  inp_group(controlName: any) {
    return this.searchFlightForm.controls[controlName];
  }

  inp_arr(controlName: any) {
    return this.inp_group(controlName) as FormArray;
  }

  addMultiCity() {
    let destinationArr = this.inp_arr('destination');
    for (let i = 0; i < 5; i++) {
      let fromGroup: any = this.formBuilder.group({
        depature: ['', [Validators.required]],
        arrival: ['', [Validators.required]],
        depatureDate: ['', [Validators.required]]
      });
      destinationArr.push(fromGroup);
    }
    this.searchFlightForm.patchValue({
      haveMultiCity: false,
      haveReturn: false
    });
  }

  removeMultiCity() {
    let destinationArr = this.inp_arr('destination');
    for (let i = 1; i < 6; i++) {
      destinationArr.removeAt(6 - i);
    }
    this.searchFlightForm.patchValue({
      haveMultiCity: true
    });
  }

  ngOnDestroy() {
    let patchSandboxSourceData = { searchFlightFormValue: this.searchFlightForm.value };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }

  closePannel() {
    let patchSandboxSourceData = { hideSideMenu: 'Yes' };
    this.sandboxPageStateService.updateSandboxDataSource(patchSandboxSourceData);
  }
}
